export default {
  getActiveBlockchain: state => state.activeBlockchain,
  getRangeFilter: state => state.rangeFilter,
}